import { render, staticRenderFns } from "./verifyGoShop.vue?vue&type=template&id=88bec4c8&scoped=true"
import script from "./verifyGoShop.vue?vue&type=script&lang=js"
export * from "./verifyGoShop.vue?vue&type=script&lang=js"
import style0 from "./verifyGoShop.vue?vue&type=style&index=0&id=88bec4c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bec4c8",
  null
  
)

export default component.exports